import React from "react";

const shimmerRow = (cols: number, key: string) => (
  <div className="flex justify-between py-1" key={key}>
    {[...Array(cols)].map((_, idx) => (
      <div
        key={idx}
        className="h-10 bg-gray-200 animate-pulse rounded w-2/5 mb-2"
      ></div>
    ))}
  </div>
);

export default function BalanceSheetShimmer() {
  return (
    <div className="relative h-maintableheight2  mx-3 mt-3 bg-white rounded-lg">
      <div className="sticky top-0 z-20 bg-white rounded-t-lg flex justify-between items-center pt-4 pb-1 pr-6 pl-4">
        <div className="h-8 bg-gray-200 animate-pulse rounded w-1/3" />
        <div className="h-8 bg-gray-200 animate-pulse rounded w-24" />
      </div>
      <div className="overflow-y-auto scrollBar px-4 pt-6 h-balanceSheetHeight">
        <div className="grid grid-cols-2 gap-8">
          {/* Assets */}
          <div>
            <div className="bg-white">
              <div className="flex justify-between bg-p_light py-3 h-12">
              </div>
              {[...Array(5)].map((_, idx) => shimmerRow(2, `assets-${idx}`))}
            </div>
          </div>
          {/* Liabilities, Equity, Revenue, Expenses, Net Income */}
          <div>
            {/* Liabilities */}
            <div className="bg-white">
            <div className="flex justify-between bg-p_light py-3 h-12">
            </div>
              {[...Array(3)].map((_, idx) => shimmerRow(2, `liabilities-${idx}`))}
              <div className="flex justify-between py-2">
                <div className="h-6 bg-gray-200 animate-pulse rounded w-1/3" />
                <div className="h-6 bg-gray-200 animate-pulse rounded w-1/4" />
              </div>
            </div>
            {/* Equity/Capital */}
            <div className="bg-white mt-1">
            <div className="flex justify-between bg-p_light py-3 h-12">
            </div>
              {[...Array(2)].map((_, idx) => shimmerRow(2, `equity-${idx}`))}
              <div className="flex justify-between py-2">
                <div className="h-6 bg-gray-200 animate-pulse rounded w-1/3" />
                <div className="h-6 bg-gray-200 animate-pulse rounded w-1/4" />
              </div>
            </div>
            {/* Revenue */}
            <div>
            <div className="flex justify-between bg-p_light py-3 h-12">
            </div>
              {[...Array(2)].map((_, idx) => shimmerRow(2, `revenue-${idx}`))}
              <div className="flex justify-between py-2">
                <div className="h-6 bg-gray-200 animate-pulse rounded w-1/3" />
                <div className="h-6 bg-gray-200 animate-pulse rounded w-1/4" />
              </div>
            </div>
            {/* Expenses */}
            <div>
            <div className="flex justify-between bg-p_light py-3 h-12">
            </div>
              {[...Array(2)].map((_, idx) => shimmerRow(2, `expenses-${idx}`))}
              <div className="flex justify-between py-2">
                <div className="h-6 bg-gray-200 animate-pulse rounded w-1/3" />
                <div className="h-6 bg-gray-200 animate-pulse rounded w-1/4" />
              </div>
            </div>
            {/* Net Income */}
            <div className="flex justify-between bg-positive opacity-30 mt-4 py-2 h-12">
            </div>
          </div>
        </div>
      <div className="flex justify-around w-full items-start gap-8 py-4">
        <div className="w-1/2">
          <div className="bg-p_light flex justify-between text-white text-title1 rounded pl-3 py-3 h-12">
          </div>
        </div>
        <div className="w-1/2 flex flex-col gap-1">
          <div className="bg-p_light flex justify-between text-white text-title1 rounded pr-3 py-3 h-12">
          </div>
          <div className="h-4 bg-gray-200 animate-pulse rounded w-2/3 mt-2" />
        </div>
      </div>
      </div>
    </div>
  );
} 